module.exports = __webpack_public_path__ + "static/assets/d1b1dc61c2137b492d784fa9142fec1e.svg";